import { Box, Link, Paper, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { UrlHelper } from '../../../../common/utils/UrlHelper';
import { SeverityBadge } from '../../../../common/instances/components/SeverityBadge';
import { PATHS } from '../../../../routing/routes';
import { Issue } from '../models/valueObjects/Issue';

type Props = {
  reportId: number;
  issue: Issue;
};

export const IssueDetails = ({ reportId, issue }: Props) => {
  const title = issue.getTitle();
  const number = issue.getNumber();
  const severity = issue.getSeverity();
  const links = issue.getLinks();

  const blocks = [
    { item: issue.getConsequences(), label: t('consequences') },
    { item: issue.getExplanation(), label: t('explanation') },
    { item: issue.getExpertise(), label: t('expertise') },
    { item: issue.getAccess(), label: t('access') },
    { item: issue.getResources(), label: t('resources') },
  ].filter(({ item }) => item);

  return (
    <Paper>
      <Box sx={{ p: 2, backgroundColor: 'grey.100', fontWeight: 700 }}>{t('issue')}</Box>
      <Box sx={{ p: 2 }}>
        <Stack direction="row" spacing={2} sx={{ height: '2rem', mb: 2 }}>
          <SeverityBadge severity={severity}>{number}</SeverityBadge>
          <Typography variant="h6" component="p" lineHeight="2rem">
            {title}
          </Typography>
        </Stack>
        <Box sx={{ mb: 2 }}>
          <Link href={UrlHelper.generatePath(PATHS.REPORT_ISSUE, { reportId: reportId.toString(), issueId: number.toString() })}>
            {t('exportsGenericLinkToAQtiveGuard')}
          </Link>
        </Box>
        {blocks.map(({ item, label }, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography fontWeight={500} gutterBottom>
              {label}
            </Typography>
            <Typography>{item}</Typography>
          </Box>
        ))}
        {links.length > 0 && (
          <Box>
            <Typography fontWeight={500} gutterBottom>
              {t('references')}
            </Typography>
            {links.map((link, index) => {
              const href = link.getHref();
              const text = link.getText();
              if (href) {
                return (
                  <Box key={index} sx={{ mb: 1 }}>
                    <Link href={href} target="_blank">
                      {text}
                    </Link>
                  </Box>
                );
              }
              return (
                <Typography key={index} component="span" sx={{ fontStyle: 'italic', lineHeight: '1.2', mb: 1 }}>
                  {text}
                </Typography>
              );
            })}
          </Box>
        )}
      </Box>
    </Paper>
  );
};
